import * as React from "react";
import { Field } from "redux-form";

import { TextArea } from "../../../components";
import { ProjectInfoFormProps } from "./ProjectInfoForm";

const AudienceField = (props: ProjectInfoFormProps) =>
  <div className="form-group">
    <label className="control-label col-md-4">
      Mô tả khác
      <p className="help-block">
        Ai sẽ là công chúng xem sản phẩm của bạn ? Bạn có muốn chúng tôi chú ý
        điều gì khi thiết kế ?
      </p>
    </label>
    <div className="col-md-8">
      <Field
        className="form-control"
        name="audience"
        component={TextArea}
        placeholder="Vd: Đối tượng là khách hàng nam - độ tuổi từ 35 -55, thành đạt, có nhu cầu mua hàng hiệu"
        rows={5}
      />
    </div>
  </div>;

export default AudienceField;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/AudienceField.tsx